import React from 'react';
import { ResizableTable } from '../../common/resizable-table';
import { TextListHolder } from './types';

import styles from './text-list-table.scss';

export const TextListTable: TextListHolder = ({
  translation, children
}) => {

  return <ResizableTable>
    <thead>
      <tr>
        <th className={styles.colId}>{translation.text_id}</th>
        <th className={styles.colTextset}>{translation.text_set}</th>
        <th className={styles.colLanguage}>{translation.language}</th>
        <th className={styles.colName}>{translation.original_text}</th>
        <th className={styles.colName}>{translation.text}</th>
      </tr>
    </thead>
    <tbody className={styles.selectableRow}>
      {children}
    </tbody>
  </ResizableTable>;
};
